/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownLetterType } from '../models/db_DropdownLetterType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LetterTypes {
    /**
     * Get a list of letter types
     * @returns db_DropdownLetterType OK
     * @throws ApiError
     */
    public static listLetterTypes(): CancelablePromise<Array<db_DropdownLetterType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/letter-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
